export default __webpack_public_path__ + "static/media/githublogo.04ed74f3.svg";